import { AppWorkerRole } from "./AppWorkerRole"
import { APIWorker } from "./Worker"

export interface APIAppWorker {
    appUuid: string
    created: string
    role: AppWorkerRole
    ownerId: number
    worker: APIWorker
}

export function getAppWorkerId(worker: APIAppWorker): string {
    return String(worker.worker.id)
}
